import React from "react";

const Spinner = () => (
    <div className="spinner-wrapper">
      <div className="spinner-container">
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
        <div className="backgroundPrimaryColor" />
      </div>
    </div>
  )

export default Spinner;
